<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>to David Kirby and Mark Pietralunga</p>
<p class="ded">il pranzo mi fa pensare</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-corrigan-0005.vue?315ade7d